import { XMarkIcon } from '@heroicons/react/24/solid';
import DOMPurify from 'dompurify';
import { ChatBubble, Modal } from 'react-daisyui';
import { useLayoutContext } from '../../../../../../../providers/LayoutProvider/Layout.context';
import { formatTime, formatDate } from '../../../../../Chat.functions';
import { tFavoriteMessageModal } from './FavoriteMessage.type';

export default function FavoriteMessageModal(
  props: tFavoriteMessageModal,
): JSX.Element {
  const { open, setOpen, messageData } = props;
  const { currentTheme } = useLayoutContext();
  const CurrentThemeClass =
    currentTheme === 'dark'
      ? 'FavoriteMessage__ModalDetails__Preview__DarkTheme'
      : 'FavoriteMessage__ModalDetails__Preview__LightTheme';
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

  const renderTextWithLinks = (text: string) => {
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        const href = part.startsWith('www.') ? `http://${part}` : part;
        return (
          <a
            key={index}
            href={href}
            className="ph-no-capture"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            {part}
          </a>
        );
      }
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(part),
          }}
        />
      );
    });
  };

  const renderTextWithNewlinesAndLinks = (text: string) => {
    const lines = text.split('\n');

    return lines.map((line, index) => (
      <div key={index}>
        {renderTextWithLinks(line)}
        {index < lines.length - 1 && <br />}
      </div>
    ));
  };

  return (
    <Modal
      open={open}
      className="FavoriteMessage__ModalDetails"
      backdrop={true}
      responsive={true}
    >
      <Modal.Body>
        <div className={CurrentThemeClass}>
          <div className="FavoriteMessage__ModalDetails__Header">
            <XMarkIcon
              onClick={() => {
                setOpen(!open);
              }}
              className="FavoriteMessage__ModalDetails__CloseIcon"
            />
          </div>
          <ChatBubble end={messageData?.message?.fromMe}>
            <ChatBubble.Message
              color={messageData?.message?.fromMe ? 'success' : 'secondary'}
            >
              {messageData?.createdBy === 'leadbot' ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      messageData?.content?.text ?? '',
                    ),
                  }}
                />
              ) : (
                renderTextWithNewlinesAndLinks(messageData?.content?.text ?? '')
              )}
            </ChatBubble.Message>
            <ChatBubble.Footer>
              <ChatBubble.Time>
                {formatDate(messageData?.createdAt)} |{' '}
                {formatTime(messageData?.createdAt)}
              </ChatBubble.Time>
            </ChatBubble.Footer>
          </ChatBubble>
        </div>
      </Modal.Body>
    </Modal>
  );
}
